<template>
	<div style="border: 1pt solid #ccc; padding: 25px">
		<p style="padding: 0 10px; font-weight: 500">
			{{ variable.node.name }}
			<el-tooltip
				style="display: inline"
				v-if="variable.isqst"
				:content="$t('question-help-important')"
				placement="top"
			>
				<md-icon style="display: inline">help</md-icon>
			</el-tooltip>
		</p>

		<field-type
			v-if="variable.node"
			ref="field"
			class="fill-input"
			:key="uuid()"
			:field="variable.node"
			@fillField="val => $emit('setField', variable, val)"
			@setValue="val => setValue(val)"
			@focusin.native="$emit('focusField', variable)"
			@focusout.native="$emit('unfocusField', variable)"
			@image="e => $emit('handleImage', variable.node.id, e, variable)"
		></field-type>
	</div>
</template>

<script>
import FieldType from "@/modules/organization/form-component/field-type"
import { uuid } from "@/modules/builder/utils/utils"

export default {
	name: "variable-input",
	components: {
		FieldType
	},
	props: {
		variable: {
			type: Object,
			required: true
		}
	},
	data: () => ({
		value: undefined
	}),
	methods: {
		uuid,
		setValue(value) {
			this.value = value
		}
	}
}
</script>
